import { gql } from "@lytra/frontend-common/__generated__";

// The "Für dich" list (#807). Every operation is named FuerDich* because operation
// names are unique across the monorepo's shared generated registry.

// One selection for every operation that returns an entry, so the list and the
// per-entry actions can never drift apart.
export const FUER_DICH_ENTRY_FIELDS = gql(`
  fragment FuerDichEntryFields on NotificationEntry {
    id
    kind
    reason
    conversationId
    conversationTitle
    messageId
    messagePreview
    actorGivenName
    actorFamilyName
    actorName
    lastEventAt
    readAt
    closedAt
    closeReason
    confirmedAt
  }
`);

// The bell's number and the "Offen" tab's number: the same query, so they never disagree.
export const FUER_DICH_OPEN_COUNT = gql(`
  query FuerDichOpenCount {
    notificationOpenCount
  }
`);

// Open tab: send `beforeAt` (the last row's lastEventAt), `beforeId` and `beforeRequest`
// (the last row's kind == REQUEST). Closed tab: `beforeAt` is the last row's closedAt.
export const FUER_DICH_ENTRIES = gql(`
  query FuerDichEntries(
    $closed: Boolean!
    $limit: Int!
    $beforeAt: DateTime
    $beforeId: UUID
    $beforeRequest: Boolean
  ) {
    notificationEntries(
      closed: $closed
      limit: $limit
      beforeAt: $beforeAt
      beforeId: $beforeId
      beforeRequest: $beforeRequest
    ) {
      ...FuerDichEntryFields
    }
  }
`);

// A signal only: the payload says nothing about what changed, the queries are the truth.
export const FUER_DICH_CHANGED = gql(`
  subscription FuerDichChanged {
    notificationsChanged {
      changed
    }
  }
`);

export const FUER_DICH_OPENED = gql(`
  mutation FuerDichOpened($conversationId: UUID!) {
    notificationOpened(conversationId: $conversationId)
  }
`);

export const FUER_DICH_MARK_READ = gql(`
  mutation FuerDichMarkRead($notificationId: UUID!) {
    notificationMarkRead(notificationId: $notificationId) {
      ...FuerDichEntryFields
    }
  }
`);

export const FUER_DICH_MARK_DONE = gql(`
  mutation FuerDichMarkDone($notificationId: UUID!) {
    notificationMarkDone(notificationId: $notificationId) {
      ...FuerDichEntryFields
    }
  }
`);

export const FUER_DICH_CONFIRM_REQUEST = gql(`
  mutation FuerDichConfirmRequest($notificationId: UUID!) {
    notificationConfirmRequest(notificationId: $notificationId) {
      ...FuerDichEntryFields
    }
  }
`);

export const FUER_DICH_REOPEN = gql(`
  mutation FuerDichReopen($notificationId: UUID!) {
    notificationReopen(notificationId: $notificationId) {
      ...FuerDichEntryFields
    }
  }
`);
